<template>
  <div class="tr">
    <slot></slot>
  </div>
</template>
